(function kangConsentBridge() {
  'use strict';

  if (window.__kangConsentBridgeLoaded) return;
  window.__kangConsentBridgeLoaded = true;
  document.documentElement.setAttribute('data-kang-consent-bridge', 'loaded');
  document.documentElement.setAttribute('data-kang-path', window.location.pathname);

  var GA4_ID = 'G-DBN9PL33Q7';
  var ADS_ID = 'AW-952419017';
  var KANG_LAB_CONVERSION = 'AW-952419017/ahFHCOaVxVkQyYWTxgM';
  var PENDING_KEY = 'kang_lab_pending_submission';
  var SENT_PREFIX = 'kang_event_sent:';

  window.__kangConsentState = 'default-denied';
  window.__kangEventLog = window.__kangEventLog || [];
  try {
    var priorEvent = sessionStorage.getItem('kang_last_event');
    if (priorEvent) document.documentElement.setAttribute('data-kang-session-last-event', priorEvent);
  } catch (error) {}
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function gtag() {
    window.dataLayer.push(arguments);
  };

  window.gtag('js', new Date());
  window.gtag('config', GA4_ID, {send_page_view: false});
  window.gtag('config', ADS_ID, {send_page_view: false});

  if (!document.querySelector('script[src*="googletagmanager.com/gtag/js"], script[data-kang-google-tag]')) {
    var googleTag = document.createElement('script');
    googleTag.async = true;
    googleTag.dataset.kangGoogleTag = 'true';
    googleTag.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(GA4_ID);
    document.head.appendChild(googleTag);
  }

  function privacyApi() {
    return window.Shopify && window.Shopify.customerPrivacy;
  }

  function updateGoogleConsent() {
    var privacy = privacyApi();
    if (!privacy) return false;

    var analyticsAllowed = privacy.analyticsProcessingAllowed() === true;
    var marketingAllowed = privacy.marketingAllowed() === true;
    var personalizationAllowed = marketingAllowed && privacy.saleOfDataAllowed() === true;

    window.gtag('consent', 'update', {
      analytics_storage: analyticsAllowed ? 'granted' : 'denied',
      ad_storage: marketingAllowed ? 'granted' : 'denied',
      ad_user_data: marketingAllowed ? 'granted' : 'denied',
      ad_personalization: personalizationAllowed ? 'granted' : 'denied'
    });
    window.gtag('set', 'ads_data_redaction', !marketingAllowed);
    window.__kangConsentState = {
      analytics_storage: analyticsAllowed ? 'granted' : 'denied',
      ad_storage: marketingAllowed ? 'granted' : 'denied',
      ad_user_data: marketingAllowed ? 'granted' : 'denied',
      ad_personalization: personalizationAllowed ? 'granted' : 'denied'
    };
    document.documentElement.setAttribute(
      'data-kang-consent-state',
      'analytics:' + (analyticsAllowed ? 'granted' : 'denied') +
      ',marketing:' + (marketingAllowed ? 'granted' : 'denied') +
      ',personalization:' + (personalizationAllowed ? 'granted' : 'denied')
    );
    return true;
  }

  function loadPrivacyApi(attempt) {
    if (updateGoogleConsent()) return;
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures(
        [{name: 'consent-tracking-api', version: '0.1'}],
        function onPrivacyReady(error) {
          if (!error) updateGoogleConsent();
        }
      );
      return;
    }
    if (attempt < 20) window.setTimeout(function () { loadPrivacyApi(attempt + 1); }, 100);
  }

  document.addEventListener('visitorConsentCollected', updateGoogleConsent);
  loadPrivacyApi(0);

  function cleanPagePath() {
    return window.location.pathname;
  }

  function uniqueEventId(prefix) {
    var randomId = window.crypto && typeof window.crypto.randomUUID === 'function'
      ? window.crypto.randomUUID()
      : Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
    return prefix + '-' + randomId;
  }

  function alreadySent(eventId) {
    try { return sessionStorage.getItem(SENT_PREFIX + eventId) === '1'; } catch (error) { return false; }
  }

  function markSent(eventId) {
    try { sessionStorage.setItem(SENT_PREFIX + eventId, '1'); } catch (error) {}
  }

  function sendGa4(name, params) {
    window.__kangEventLog.push({name: name, event_id: params && params.event_id, page_path: cleanPagePath()});
    try { sessionStorage.setItem('kang_last_event', name); } catch (error) {}
    document.documentElement.setAttribute('data-kang-last-event', name);
    document.documentElement.setAttribute('data-kang-event-count', String(window.__kangEventLog.length));
    window.gtag('event', name, Object.assign({send_to: GA4_ID}, params || {}));
  }

  function sendOnce(name, eventId, params) {
    if (!eventId || alreadySent(eventId)) return false;
    markSent(eventId);
    sendGa4(name, Object.assign({event_id: eventId, page_path: cleanPagePath()}, params || {}));
    return true;
  }

  function isKangLabForm(form) {
    return Boolean(form) && window.location.pathname === '/pages/brief-kang-lab';
  }

  function rememberPendingSubmission(form) {
    if (!isKangLabForm(form)) return;
    if (window.__kangPendingSubmission) {
      document.documentElement.setAttribute('data-kang-form-state', 'pending');
      return;
    }

    var pending;
    try {
      var stored = sessionStorage.getItem(PENDING_KEY);
      if (stored) pending = JSON.parse(stored);
    } catch (error) {}

    if (!pending || !pending.eventId) {
      pending = {eventId: uniqueEventId('kang-lab'), createdAt: Date.now()};
    }
    window.__kangPendingSubmission = pending;
    try { sessionStorage.setItem(PENDING_KEY, JSON.stringify(pending)); } catch (error) {}
    document.documentElement.setAttribute('data-kang-form-state', 'pending');
  }

  function successVisible() {
    if (window.location.pathname !== '/pages/brief-kang-lab') return false;

    function containsSuccess(root) {
      if (!root) return false;
      if (!root.querySelectorAll) return false;
      var nodes = root.querySelectorAll('*');
      for (var index = 0; index < nodes.length; index += 1) {
        if (nodes[index].shadowRoot && containsSuccess(nodes[index].shadowRoot)) return true;
        var text = (nodes[index].textContent || '').trim();
        if (
          text.indexOf('SOLICITUD RECIBIDA') !== -1 &&
          text.length < 500 &&
          nodes[index].getClientRects().length > 0 &&
          window.getComputedStyle(nodes[index]).visibility !== 'hidden'
        ) return true;
      }
      return false;
    }

    return containsSuccess(document);
  }

  function sendSuccessfulSubmission() {
    if (!successVisible()) return;
    var pending = window.__kangPendingSubmission;
    if (!pending) {
      try {
        var raw = sessionStorage.getItem(PENDING_KEY);
        if (raw) pending = JSON.parse(raw);
      } catch (error) {}
    }
    if (!pending) return;

    try {
      if (!pending.eventId || Date.now() - pending.createdAt > 30 * 60 * 1000) {
        window.__kangPendingSubmission = null;
        try { sessionStorage.removeItem(PENDING_KEY); } catch (storageError) {}
        return;
      }
      if (sendOnce('kang_lab_form_submit', pending.eventId, {form_id: '1137843'})) {
        window.gtag('event', 'conversion', {
          send_to: KANG_LAB_CONVERSION,
          transaction_id: pending.eventId
        });
        document.documentElement.setAttribute('data-kang-form-state', 'sent');
      }
      window.__kangPendingSubmission = null;
      try { sessionStorage.removeItem(PENDING_KEY); } catch (storageError) {}
    } catch (error) {
      window.__kangPendingSubmission = null;
      try { sessionStorage.removeItem(PENDING_KEY); } catch (storageError) {}
    }
  }

  document.addEventListener('submit', function onSubmit(event) {
    rememberPendingSubmission(event.target);
  }, true);

  document.addEventListener('click', function onClick(event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var submitButton = target.closest('button');
    if (
      submitButton &&
      window.location.pathname === '/pages/brief-kang-lab' &&
      submitButton.textContent.indexOf('SOLICITAR COTIZACIÓN') !== -1
    ) {
      rememberPendingSubmission(submitButton.closest('form') || document);
    }

    var link = target.closest('a[href]');
    if (!link) return;

    var href = link.getAttribute('href') || '';
    if (/wa\.me|api\.whatsapp\.com|whatsapp\.com\/send/i.test(href)) {
      sendOnce('whatsapp_click', uniqueEventId('whatsapp'), {link_type: 'whatsapp'});
    }

    if (window.location.pathname === '/pages/kang-lab' && href.indexOf('/pages/brief-kang-lab') !== -1) {
      sendOnce('kang_lab_quote_click', uniqueEventId('kang-lab-quote'), {
        destination_path: '/pages/brief-kang-lab'
      });
    }
  }, true);

  function initializeKangLabTracking() {
    document.documentElement.setAttribute('data-kang-tracking-init', 'ready');
    if (!successVisible()) rememberPendingSubmission(document);
    sendSuccessfulSubmission();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeKangLabTracking, {once: true});
  } else {
    initializeKangLabTracking();
  }

  new MutationObserver(sendSuccessfulSubmission).observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  if (window.location.pathname === '/pages/brief-kang-lab') {
    window.setInterval(sendSuccessfulSubmission, 500);
  }
}());
